const STEPS = [
  {
    n: "00",
    title: "Refine your idea.",
    body: (
      <>
        Use this Value Proposition GPT to hone it in.{" "}
        <a
          href="https://chatgpt.com/g/g-8NEDkW4tJ-value-proposition-canvas"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="step-00-vp-gpt-link"
          className="text-yellow-400 underline underline-offset-4 decoration-yellow-400/40 hover:decoration-yellow-400"
        >
          Click here to dial in your idea!
        </a>
      </>
    ),
    tag: "week 0",
  },
  {
    n: "01",
    title: "Kick Off",
    body:
      "We meet to go over your Ideal Customer Profile (ICP) with your unique value proposition (UVP).",
    tag: "week 1",
  },
  {
    n: "02",
    title: "Invisible Deployment",
    body:
      "We launch quietly into the messaging app of your choice. Real users. Real traffic. Real telemetry — without a single new app icon on their screen.",
    tag: "week 2",
  },
  {
    n: "03",
    title: "Email-Based Change Requests",
    body:
      "You email what you want changed. We confirm the spec, batch the work, and ship. No real-time chat. No after-hours pings. Just calm, deliberate iteration.",
    tag: "week 3",
  },
  {
    n: "04",
    title: "Quiet, Continuous Care",
    body:
      "Monitoring runs in the background. Incidents are handled by humans. You hear from us when you need to — and not a moment sooner.",
    tag: "week 4",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="process"
      data-testid="how-it-works-section"
      className="relative py-24 md:py-32 border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-12">
          <span className="text-xs uppercase tracking-[0.22em] text-zinc-500 font-mono">
            §05 · How It Works
          </span>
        </div>

        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight font-light leading-snug max-w-3xl mb-20">
          From first email to forever.
          <br />
          <span className="text-zinc-500">Five quiet steps.</span>
        </h2>

        <div className="relative">
          {/* vertical line */}
          <div className="absolute left-[11px] md:left-1/2 top-0 bottom-0 w-px bg-white/10 md:-translate-x-1/2" />

          <ol className="space-y-12 md:space-y-16">
            {STEPS.map((s, i) => (
              <li
                key={s.n}
                data-testid={`process-step-${s.n}`}
                className={`relative grid md:grid-cols-2 gap-8 md:gap-16 ${i % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}
              >
                <div className="relative pl-10 md:pl-0 md:pr-12 md:text-right">
                  {/* dot */}
                  <span className="absolute left-0 top-1 md:left-auto md:right-[-7px] md:top-2 w-4 h-4 border border-yellow-400 bg-black flex items-center justify-center">
                    <span className="w-1.5 h-1.5 bg-yellow-400" />
                  </span>
                  <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-yellow-400 mb-3">
                    {s.tag}
                  </div>
                  <div className="font-heading text-5xl md:text-6xl font-extralight text-white/90 tracking-tighter">
                    {s.n}
                  </div>
                </div>

                <div className="pl-10 md:pl-12">
                  <h3 className="font-heading text-2xl font-light tracking-tight text-white mb-3">
                    {s.title}
                  </h3>
                  <p className="text-base leading-relaxed text-zinc-400 font-light max-w-md">
                    {s.body}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
